/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_ExcerptInputs */

const cs_blog_excerpt = /** @type {(inputs: Blog_ExcerptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perex`)
};

const en_blog_excerpt = /** @type {(inputs: Blog_ExcerptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excerpt`)
};

/**
* | output |
* | --- |
* | "Excerpt" |
*
* @param {Blog_ExcerptInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_excerpt = /** @type {((inputs?: Blog_ExcerptInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_ExcerptInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_excerpt(inputs)
	return cs_blog_excerpt(inputs)
});